import { memo } from 'react';
import { useTour } from '@reactour/tour';
import CloseIcon from '@mui/icons-material/Close';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Redesign-styled step popover for reactour tours (a dark counterpart to the shared light
// `OnboardingStep`, which powers the legacy tours). Renders inside the portaled popover, so it wraps its
// root in `redesign` to bring the redesign tokens/font into the portal. On the last step the primary
// button reads "Done" and closes the tour; otherwise it advances to the next step.
export const RedesignOnboardingStep = memo(({ children, disableArrows, disableDots, disableNext }) => {
    const tour = useTour();
    const isLastStep = tour.currentStep >= tour.steps.length - 1;
    const cardClass = 'redesign relative flex flex-col gap-4 rounded-2xl border border-solid border-white/[0.08] bg-card p-4 text-foreground shadow-2xl shadow-black/50';
    if (disableArrows && disableDots) {
        return <div className={cardClass}>{children}</div>;
    }
    return (<div className={cardClass}>
			{children}
			<button type="button" aria-label="Close tour" onClick={() => tour.setIsOpen(false)} className="absolute -right-2 -top-2 flex size-7 items-center justify-center rounded-full border border-solid border-white/[0.08] bg-card">
				<CloseIcon sx={{ fontSize: 16, color: '#b9bcc1', '& path': { fill: '#b9bcc1' } }}/>
			</button>
			<div className="flex items-center justify-between">
				{!disableDots && (<ul className={cn('flex gap-1.5', disableArrows && 'w-full justify-center')}>
						{tour.steps.map((_, stepIndex) => {
                const isFilled = stepIndex <= tour.currentStep;
                return (<li 
                // eslint-disable-next-line react/no-array-index-key
                key={stepIndex.toString()} className={cn('size-2 rounded-full bg-white/[0.15]', isFilled && 'bg-primary')}/>);
            })}
					</ul>)}
				{!disableArrows && (<div className="flex items-center gap-2">
						<button type="button" onClick={() => tour.setCurrentStep(prev => (prev > 0 ? prev - 1 : prev))} className="text-xs font-medium text-muted-foreground transition-colors hover:text-foreground">
							Back
						</button>
						{!disableNext && (<button type="button" onClick={() => {
                    if (isLastStep) {
                        tour.setIsOpen(false);
                        return;
                    }
                    tour.setCurrentStep(prev => (prev < tour.steps.length - 1 ? prev + 1 : prev));
                }} className="rounded-lg bg-primary px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-primary/90">
								{isLastStep ? 'Done' : 'Continue'}
							</button>)}
					</div>)}
			</div>
		</div>);
});
